import styled from '@emotion/styled';
import { IBoxProps } from './types';

export const Container = styled.div<IBoxProps>`
  display: flex;
`;
